// src/Components/Actions/CartPopup.jsx
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Cart.css";
import itemImg from "../../../../Assets/items.png";

export default function CartPopup({
  isOpen,
  onClose,
  cart = {},
  setCart,
  items = [],
}) {
  const navigate = useNavigate();

  // ---------------- CART ITEMS ----------------
  const cartItems = useMemo(() => {
    const getQty = (id) => cart[id] ?? cart[String(id)] ?? 0;

    return items
      .map((item) => {
        const qty = getQty(item.id);
        return qty > 0 ? { ...item, quantity: qty } : null;
      })
      .filter(Boolean);
  }, [cart, items]);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  // ⛔ IMPORTANT: early return AFTER hooks
  if (!isOpen) return null;

  // ---------------- CART ACTIONS ----------------
  const increaseQty = (id) => {
    setCart((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setCart((prev) => {
      const updated = { ...prev };
      if (updated[id] > 1) updated[id] -= 1;
      else delete updated[id];
      return updated;
    });
  };

  const handleClear = () => {
    setCart({});
    onClose();
  };

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      alert("Cart is empty!");
      return;
    }
    onClose();
    navigate("/cart-summary");
  };

  // ---------------- RENDER ----------------
  return (
    <div className="cart-overlay">
      <div className="cart-popup">
        {/* HEADER */}
        <div className="cart-header">
          <h2>Your Cart</h2>
          <span className="cart-close-icon" onClick={onClose}>×</span>
        </div>

        <p className="cart-subtitle">({cartItems.length} items)</p>

        {/* ITEMS */}
        <div className="cart-items-section">
          {cartItems.length ? (
            cartItems.map((item) => (
              <div key={item.id} className="cart-item">
                <img
                  src={item.image_url || itemImg}
                  alt={item.name}
                  className="cart-item-image"
                />

                <div className="cart-item-details">
                  <p className="cart-item-name">{item.name}</p>
                </div>

                <div className="cart-price">₹{item.price}</div>

                <div className="cart-qty-box">
                  <button onClick={() => decreaseQty(item.id)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => increaseQty(item.id)}>+</button>
                </div>
              </div>
            ))
          ) : (
            <p className="empty-cart-text">🛒 No items in cart</p>
          )}
        </div>

        {/* FOOTER */}
        <div className="cart-footer">
          <div className="cart-total-row">
            <span>Total</span>
            <span>₹{totalAmount.toFixed(2)}</span>
          </div>

          <div className="cart-actions">
            <button className="cart-clear-btn" onClick={handleClear}>
              Clear All
            </button>
            <button className="cart-checkout-btn" onClick={handleCheckout}>
              Checkout →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
